<template>
  <div>
    <Main
      :title="title"
      :theme-type="themeType"
      :height="height"
      :columns="tableColumns"
      :data="tableData"
      :loading="loading"
      :tableKey="tableKey"
      @upload-change="uploadChange"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import * as XLSX from 'xlsx'
export default {
  components: { Main },
  props: {
    title: { type: String, default: '文件列表' },
    themeType: { type: String, default: '' },
    height: { type: Number, default: 0 },
    tableKey: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: [],
      loading: false,
      skipHidden: false,
    }
  },
  methods: {
    async uploadChange(file, skipHidden = false) {
      if (!file) return
      this.loading = true
      const { json, csv } = await this.readFile(file, skipHidden)
      if (!csv) {
        this.$message.error('该文件无内容，无法比对！')
        this.loading = false
        return
      }

      const cols = csv.split('<--RS-->')[0].split('<--FS-->')

      if (!json || !json.length) {
        this.$message.error('该文件无数据，无法比对！')
        this.loading = false
        return
      }

      const colsIndex = {}
      const _columns = cols.map((col, index) => {
        const colKey = ['__EMPTY', ''].includes(col) ? '__EMPTY' : col
        colsIndex[colKey] = colsIndex[colKey] || 0
        const colIndex = colsIndex[colKey]
        colsIndex[colKey]++

        const label = col.replaceAll('\r\n', '\n')
        return {
          label: label,
          value: !colIndex ? colKey : `${colKey}_${colIndex}`,
          field: `${label}_${index}`,
        }
      })

      const data = json.map((row) =>
        Object.fromEntries(
          _columns.map(({ value, field }) => [
            field,
            row[value]?.replaceAll('\r\n', '\n'),
          ])
        )
      )
      const columns = _columns.map(({ label, field }) => ({ label, field }))

      this.tableData = data
      this.tableColumns = columns
      this.$emit('change', { data, columns })
      this.loading = false
    },
    async readFile(file, skipHidden = false) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (ev) => {
          const binary = ev.target.result
          if (!binary) return
          const workbook = XLSX.read(binary, {
            type: 'binary',
            sheets: 0,
            cellStyles: true,
          })
          const { SheetNames, Sheets } = workbook
          const jsonOpts = {
            defval: '',
            skipHidden,
            raw: false,
            rawNumbers: false,
          }
          const json = XLSX.utils.sheet_to_json(Sheets[SheetNames[0]], jsonOpts)
          const csvOpts = {
            FS: '<--FS-->',
            RS: '<--RS-->',
            skipHidden,
            rawNumbers: false,
          }
          const csv = XLSX.utils.sheet_to_csv(Sheets[SheetNames[0]], csvOpts)
          resolve({ json, csv })
        }
        reader.readAsBinaryString(file)
      })
    },
  },
}
</script>
